import $axios from './index'

export function login(data) {
  const url = '/api/auth/userManage/loginByPwd'
  return $axios.post(url, data)
}

// export function getMenuList(data) {
//   const url = '/auth/getUserInfo'
//   return $axios.get(url, data)
// }

export function getInfo(data) {
  const url = '/api/auth/userManage/auth/getUserInfo'
  return $axios.get(url, data)
}


export function getRsa(data){
  const url = '/api/auth/userManage/loginByRsa'
  return $axios.post(url, data)
}

//
export function changePassword(data){
  const url = '/api/auth/userManage/auth/updateUserPassword'
  return $axios.put(url, data)
}

